import { defaultSections } from "@reactive-resume/schema";
import {
  RichInput,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";
import { useState } from "react";

import { AiActions } from "@/client/components/ai-actions";
import { useResumeStore } from "@/client/stores/resume";

import { getSectionIcon, SectionIcon } from "./shared/section-icon";
import { SectionOptions } from "./shared/section-options";
import { SectionHeader } from "@/client/pages/builder/_components/SectionHeader";
import { t } from "@lingui/macro";

type Props = {
  openedDataSection: string | undefined;
  setOpenedDataSection: (a: string) => void;
};

export const SummarySection = ({ openedDataSection, setOpenedDataSection }: Props) => {
  const setValue = useResumeStore((state) => state.setValue);
  const section = useResumeStore(
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    (state) => state.resume.data.sections.summary ?? defaultSections.summary,
  );

  return (
    <section id="summary" className="grid gap-y-6">
      <Accordion
        type="single"
        collapsible
        value={openedDataSection}
        onValueChange={setOpenedDataSection}
      >
        <AccordionItem value="summary" className="border-none">
          <div className="hover:decoration-none! relative flex w-full items-center justify-between [&>h3]:w-full [&>h3]:cursor-pointer">
            <AccordionTrigger className="w-full flex-1 rounded-sm px-2 py-1">
              <SectionHeader icon="summary" title={section.name} />
            </AccordionTrigger>
            {openedDataSection === "summary" && (
              <div className="absolute top-1 right-5 flex items-center gap-x-2">
                <SectionOptions id="summary" />
              </div>
            )}
          </div>

          <AccordionContent>
            <main className={cn("mt-4", !section.visible && "opacity-50")}>
              <RichInput
                content={section.content}
                footer={(editor) => (
                  <AiActions
                    value={editor.getText()}
                    onChange={(value) => {
                      editor.commands.setContent(value, true);
                      setValue("sections.summary.content", value);
                    }}
                  />
                )}
                onChange={(value) => {
                  setValue("sections.summary.content", value);
                }}
              />
            </main>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </section>
  );
};
